export const CONNECT_REWARDS_AND_STAKING = 'CONNECT_REWARDS_AND_STAKING';
export const SET_CHECKIN_STATE = 'SET_CHECKIN_STATE';
export const SET_CHECKOUT_STATE = 'SET_CHECKOUT_STATE';
export const SET_STAKED_DAYCARE_REWARDS_STATE =
	'SET_STAKED_DAYCARE_REWARDS_STATE';
export const SET_NOT_STAKED_DAYCARE_REWARDS_STATE =
	'SET_NOT_STAKED_DAYCARE_REWARDS_STATE';
export const SET_HIDEOUT_REWARDS_STATE = 'SET_HIDEOUT_REWARDS_STATE';
export const RESET_REWARDS_STATE = 'RESET_REWARDS_STATE';
